module.exports = __webpack_public_path__ + "img/building-wall-panels-2.5ada4deb.jpeg";